<div class="modal-header">
  <h5 class="modal-title">Delete client</h5>
  <button type="button" class="btn-close" aria-label="Close" (click)="cancel()"></button>
</div>
<form (ngSubmit)="confirm()">
  <div class="modal-body">
    <p>
      This will permanently delete client <strong>{{ clientName }}</strong>.
      This action cannot be undone.
    </p>
    <p class="text-danger small">
      Users of this client will no longer be able to sign in.
      Users, offers, RFPs and other records linked to this client are not deleted.
    </p>
    <label for="deleteClientName" class="form-label">
      Type <strong>{{ clientName }}</strong> to confirm
    </label>
    <input id="deleteClientName"
           name="deleteClientName"
           class="form-control"
           autocomplete="off"
           [(ngModel)]="typedName" />
  </div>
  <div class="modal-footer d-flex justify-content-end">
    <button type="button" class="btn btn-secondary" (click)="cancel()">Cancel</button>
    <button type="submit" class="btn btn-danger" [disabled]="!canDelete">Delete</button>
  </div>
</form>
